const getApiUrl = (): string => {
  const hostname = window.location.hostname;

  // Handle local development case
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return 'http://localhost:8080/v1';
  }

  // Construct the API URL by replacing 'app.' with 'api.' if present,
  // ensuring the correct API endpoint is targeted relative to where the app is hosted.
  const rootDomain = hostname.replace('app.', '');
  return `https://api.${rootDomain}/v1`;
};

const ENVIRONMENT_VARIABLES = {
  Base_API_URL: getApiUrl(),
};

export const DATE_FORMAT = 'DD/M/YYYY';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'DD/M/YYYY HH:mm';

export default ENVIRONMENT_VARIABLES;

export const DEFAULT_TOP_CHIP = 50;
export const TRIAL_BET_LIMIT = 2000;
export const TRIAL_DEFAULT_BALANCE = 10000;
